var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCommunicationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "#e0a553",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.3342 27.9332L20.8111 17.1116C19.7289 16.6306 18.5265 17.5925 19.0075 18.6747L22.0135 26.7308L35.7209 29.0154L22.0135 31.3L19.0075 39.3561C18.6468 40.4383 19.7289 41.4002 20.8111 40.799L42.3342 29.9773C43.1759 29.6166 43.1759 28.4142 42.3342 27.9332Z",
    fill: "#de4848"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommunicationIcon);
export default __webpack_public_path__ + "static/media/communication-icon.b23ba1ac3b90ffca6fe48435f68cb08f.svg";
export { ForwardRef as ReactComponent };